/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_Invoice_NoInputs */

const vi_receipt_label_invoice_no = /** @type {(inputs: Receipt_Label_Invoice_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn hàng`)
};

/**

* @param {Receipt_Label_Invoice_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_invoice_no = /** @type {((inputs?: Receipt_Label_Invoice_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_Invoice_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_invoice_no(inputs)
});